export default {
  email: 'Email address',
  memberEmail: `Member's email address`,
  roles: 'Roles',
}
